import { jsx as _jsx } from "react/jsx-runtime";
export const Description = ({ description, className, }) => (_jsx("p", { className: className, children: description }));
